import { runMigrations, SchemaVersionError } from '../../lib/storage/migrations';
import type { SyncedTree } from '../../lib/types';

// Parse an exported JSON backup, run schema migrations, and return a tree
// safe to load into the synced store. Throws on malformed JSON, missing or
// newer schemaVersion, or missing entity arrays.

const REQUIRED_KEYS = ['schemaVersion', 'syncCode', 'settings', 'meta', 'profiles'] as const;

export function parseImportedTree(raw: string): SyncedTree {
  let data: unknown;
  try {
    data = JSON.parse(raw);
  } catch {
    throw new Error('Tiedosto ei ole kelvollista JSONia.');
  }
  if (!data || typeof data !== 'object') {
    throw new Error('Varmuuskopio on virheellisessä muodossa.');
  }
  const obj = data as Record<string, unknown>;
  for (const key of REQUIRED_KEYS) {
    if (!(key in obj)) {
      throw new Error(`Varmuuskopiosta puuttuu kenttä '${key}'.`);
    }
  }
  if (!Array.isArray(obj.profiles)) {
    throw new Error("'profiles' ei ole lista.");
  }
  try {
    return runMigrations(obj as unknown as SyncedTree);
  } catch (err) {
    if (err instanceof SchemaVersionError) {
      throw new Error('Varmuuskopio on uudemmasta versiosta — päivitä sovellus ensin.');
    }
    throw new Error('Varmuuskopion versio on virheellinen.');
  }
}
